import React from 'react';
import { Theme } from '@mui/material';

import { makeStyles } from 'tss-react/mui';

import { Card, ImageListItem } from '@hbf/dsl';

import { getGridSize } from './helpers';
import { MAX_IMAGES_PER_COL } from './constants';
import { ImageGridColContainer } from './ImageGridColContainer';

const noop = () => undefined;

const useStyles = makeStyles()((theme: Theme) => ({
  cardStyles: {
    position: 'relative',
    height: '100%',
    width: '100%',
    transform: 'scale(1)',
    transition: 'transform 250ms cubic-bezier(0.4, 0, 0.2, 1)',
    '&:hover': {
      transform: 'scale(1.015)',
    },
    boxShadow: 'none !important',
  },
  placeHolder: {
    position: 'relative',
    height: '100%',
    width: '100%',
    backgroundColor: theme.palette.grey[50],
  },
  tile: {
    [theme.breakpoints.down('md')]: {
      // MuiGridListTile-root has an inline style padding
      // This is added to remove
      paddingLeft: '0 !important',
      paddingRight: '0 !important',
    },
  },
}));

interface Props {
  numPhotos: number;
}

export const ImageGridColSkeleton: React.FC<Props> = ({ numPhotos }) => {
  const { classes } = useStyles();
  const numTiles = Math.min(numPhotos, MAX_IMAGES_PER_COL);

  return (
    <ImageGridColContainer>
      {Array(numTiles)
        .fill(0)
        .map((_el, idx) => (
          <ImageListItem
            key={idx}
            onClick={noop}
            {...getGridSize(numTiles, idx)}
            classes={{
              root: classes.tile,
            }}
          >
            <Card square className={classes.cardStyles}>
              <div className={classes.placeHolder} />
            </Card>
          </ImageListItem>
        ))}
    </ImageGridColContainer>
  );
};
